import type { Router } from 'vue-router'

export default (router: Router) => {
  router.addRoute({
    path: '/store',
    name: 'MarketPage',
    redirect: '/dashboard',
    children: [
      {
        path: '/store/vps',
        name: 'MarketPageVm',
        component: () => import('@/modules/market/views/MarketPageVm.vue'),
      },
      {
        path: '/store/wp',
        name: 'MarketPageWp',
        component: () => import('@/modules/market/views/MarketPageWp.vue'),
      },
      {
        path: '/store/vpc',
        name: 'MarketPageVpc',
        component: () => import('@/modules/market/views/MarketPageVpc.vue'),
      },
      {
        path: '/store/ssl',
        name: 'MarketPageSsl',
        component: () => import('@/modules/market/views/MarketPageSsl.vue'),
      },
      {
        path: '/store/blackbox',
        name: 'MarketPageNextcloud',
        component: () => import('@/modules/market/views/MarketPageNextcloud.vue'),
      },
    ],
    meta: {
      layout: 'DefaultLayout',
    },
  })
}
